module.exports = __webpack_public_path__ + "static/media/login.b2f8e31a.svg";